import Configuration from "./Configuration";
import SoftwareLicenceLink from "./SoftwareLicenceLink";
import _Model from "./_Model";

export default class SoftwareLicence extends _Model {
  constructor(json) {
    super(json);
    this.id = SoftwareLicence.getOrDefault(json, 'id', '');
    this.quantity = SoftwareLicence.getMappedOrDefault(json, 'quantity', 0, v => parseInt(v));
    this.licenceCategory = SoftwareLicence.getOrDefault(json, 'licenceCategory', '');
    this.licenceGroup = SoftwareLicence.getOrDefault(json, 'licenceGroup', '');
    this.configuration = SoftwareLicence.getMappedOrDefault(json, 'configuration', null, data => new Configuration(data));
    this.selectorOrigin = SoftwareLicence.getOrDefault(json, 'selectorOrigin', null);
    this.licenceType = SoftwareLicence.getOrDefault(json, 'licenceType', '');
    this.description = SoftwareLicence.getOrDefault(json, 'description', '');
    this.licenseModel = SoftwareLicence.getOrDefault(json, 'licenseModel', null);
    this.hardwareCompatible = SoftwareLicence.getOrDefault(json, 'hardwareCompatible', false);
    this.links = SoftwareLicence.getMappedOrDefault(json, 'links', [], data => (data || []).map(l => new SoftwareLicenceLink(l)));
    this.licenseLevel = SoftwareLicence.getOrDefault(json, 'licenseLevel', null);
  }
}
